module.exports = __webpack_public_path__ + "static/img/Gacha17.67e84b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/gasha/Gacha17.png
// module id = 77Nx
// module chunks = 1